import {
  Home,
  Users,
  Package,
  Plus,
  Wrench,
  Settings,
  FileText,
  ClipboardCheck,
  Building2,
  CheckSquare,
  LogOut,
  Clock,
  UserCheck,
} from "lucide-react";

export const managernavigationLinks = [
  { id: 1, title: "Home", path: "", icon: Home },
  {
    id: 2,
    title: "Users",
    path: "users",
    icon: Users,
    submenu: [
      { id: 201, title: "Supervisor", path: "users?tab=supervisor" },
      { id: 202, title: "Technician", path: "users?tab=technician" },
    ],
  },
  {
    id: 3,
    title: "Assets",
    path: "assets/building",
    icon: Package,
    submenu: [
      { id: 301, title: "Building", path: "assets/building" },
      { id: 302, title: "Landscaping", path: "assets/landscaping" },
      { id: 303, title: "Machinery", path: "assets/machinery" },
      { id: 305, title: "Room", path: "assets/room" },
    ],
  },
  { id: 4, title: "Asset Category", path: "category", icon: Plus },
  {
    id: 5,
    title: "Repair and Maintenance",
    path: "repair-maintenance",
    icon: Wrench,
    submenu: [
      { id: 501, title: "All Repairs", path: "repair-maintenance" },
      { id: 502, title: "Pending", path: "repair-maintenance?status=pending" },
      { id: 503, title: "In Progress", path: "repair-maintenance?status=in progress" },
      { id: 504, title: "Completed", path: "repair-maintenance?status=completed" },
    ],
  },
  {
    id: 6,
    title: "Preventive Maintenance",
    path: "preventive-maintenance",
    icon: Settings,
    submenu: [
      { id: 601, title: "All Maintenance", path: "preventive-maintenance" },
      { id: 602, title: "Pending", path: "preventive-maintenance?status=pending" },
      { id: 603, title: "In Progress", path: "preventive-maintenance?status=in progress" },
      { id: 604, title: "Completed", path: "preventive-maintenance?status=completed" },
    ],
  },
  {
    id: 7,
    title: "Repair Report",
    path: "repair-report",
    icon: FileText,
  },
  {
    id: 8,
    title: "Maintenance Report",
    path: "maintenance-report",
    icon: ClipboardCheck,
  },
  { id: 9, title: "Attendance", path: "attendance", icon: UserCheck },
  { id: 10, title: "Vendor", path: "vendor", icon: Building2 },
  { id: 11, title: "Feedback", path: "feedback", icon: FileText },
  { id: 12, title: "Overtime", path: "overtime", icon: Clock },
];

export const techniciannavigationLinks = [
  { id: 1, title: "Home", path: "", icon: Home },
  {
    id: 2,
    title: "Work Order",
    path: "work-order",
    icon: Settings,
    submenu: [
      { id: 201, title: "All Works", path: "work-order" },
      { id: 202, title: "Pending", path: "work-order?status=pending" },
      { id: 203, title: "In Progress", path: "work-order?status=in progress" },
      { id: 204, title: "Completed", path: "work-order?status=completed" },
    ],
  },
  {
    id: 3,
    title: "Maintenance Schedule",
    path: "maintenance-schedule",
    icon: ClipboardCheck,
    submenu: [
      { id: 301, title: "All Schedules", path: "maintenance-schedule" },
      { id: 302, title: "Pending", path: "maintenance-schedule?status=pending" },
      { id: 303, title: "In Progress", path: "maintenance-schedule?status=in progress" },
      { id: 304, title: "Completed", path: "maintenance-schedule?status=completed" },
    ],
  },
  { id: 4, title: "Attendance", path: "attendance", icon: UserCheck },
  { id: 5, title: "Overtime", path: "overtime", icon: Clock },
];

export const adminnavigationLinks = [
  { id: 1, title: "Home", path: "", icon: Home },
  { id: 2, title: "Academies", path: "academies", icon: Building2 },
  {
    id: 3,
    title: "Users",
    path: "users",
    icon: Users,
    submenu: [
      { id: 301, title: "Manager", path: "users?tab=Manager" },
      { id: 302, title: "Supervisor", path: "users?tab=Supervisor" },
      { id: 303, title: "Technician", path: "users?tab=Technician" },
      { id: 304, title: "CFM", path: "users?tab=CFM" },
      { id: 305, title: "Department", path: "users?tab=Department" },
      { id: 306, title: "Division", path: "users?tab=Division" },
      { id: 307, title: "Role", path: "users?tab=Role" },
    ],
  },
  {
    id: 4,
    title: "Assets",
    path: "assets/building",
    icon: Package,
    submenu: [
      { id: 401, title: "Building", path: "assets/building" },
      { id: 402, title: "Landscaping", path: "assets/landscaping" },
      { id: 403, title: "Machinery", path: "assets/machinery" },
      { id: 405, title: "Room QR", path: "assets/room" },
      // { id: 406, title: "Other", path: "assets/other" },
    ],
  },
  {
    id: 5,
    title: "Asset Approval",
    path: "approval",
    icon: CheckSquare,
    submenu: [
      { id: 501, title: "Creation Approval", path: "approval?tab=creation" },
      { id: 502, title: "Deletion Approval", path: "approval?tab=deletion" },
    ],
  },
  {
    id: 6,
    title: "Repair and Maintenance",
    path: "repair-maintenance",
    icon: Wrench,
    submenu: [
      { id: 601, title: "All Repairs", path: "repair-maintenance" },
      { id: 602, title: "Pending", path: "repair-maintenance?status=pending" },
      { id: 603, title: "In Progress", path: "repair-maintenance?status=in progress" },
      { id: 604, title: "Completed", path: "repair-maintenance?status=completed" },
    ],
  },
  {
    id: 7,
    title: "Preventive Maintenance",
    path: "preventive-maintenance",
    icon: Settings,
    submenu: [
      { id: 701, title: "All Maintenance", path: "preventive-maintenance" },
      { id: 702, title: "Pending", path: "preventive-maintenance?status=pending" },
      { id: 703, title: "In Progress", path: "preventive-maintenance?status=in progress" },
      { id: 704, title: "Completed", path: "preventive-maintenance?status=completed" },
    ],
  },
  {
    id: 8,
    title: "Repair Report",
    path: "repair-report",
    icon: FileText,
  },
  {
    id: 9,
    title: "Maintenance Report",
    path: "maintenance-report",
    icon: ClipboardCheck,
  },
  { id: 10, title: "Attendance", path: "attendance", icon: UserCheck },
  { id: 11, title: "Vendor", path: "vendor", icon: Building2 },
  { id: 12, title: "Feedback", path: "feedback", icon: FileText },
];

export const cfmnavigationLinks = [
  { id: 1, title: "Home", path: "", icon: Home },
  { id: 2, title: "Users", path: "users", icon: Users },
  { id: 3, title: "Attendance", path: "attendance", icon: UserCheck },
  { id: 4, title: "Vendor", path: "vendor", icon: Building2 },
  { id: 5, title: "Feedback", path: "feedback", icon: FileText },
];

export const sadminnavigationLinks = [
  { id: 1, title: "Home", path: "", icon: Home },
  { id: 2, title: "Academies", path: "academies", icon: Building2 },
  { id: 3, title: "Users", path: "users", icon: Users },
  {
    id: 4,
    title: "Assets",
    path: "assets",
    icon: Package,
    submenu: [
      { id: 401, title: "Building", path: "assets/building" },
      { id: 402, title: "Landscaping", path: "assets/landscaping" },
      { id: 403, title: "Machinery", path: "assets/machinery" },
      { id: 405, title: "Room QR", path: "assets/room" },
    ],
  },
  {
    id: 5,
    title: "Repair and Maintenance",
    path: "repair-maintenance",
    icon: Wrench,
  },
  {
    id: 6,
    title: "Preventive Maintenance",
    path: "preventive-maintenance",
    icon: Settings,
  },
  {
    id: 7,
    title: "Repair Report",
    path: "repair-report",
    icon: FileText,
  },
  {
    id: 8,
    title: "Maintenance Report",
    path: "maintenance-report",
    icon: ClipboardCheck,
  },
  { id: 9, title: "Attendance", path: "attendance", icon: UserCheck },
  { id: 10, title: "Vendor", path: "vendor", icon: Building2 },
  { id: 11, title: "Feedback", path: "feedback", icon: FileText },
];

export const supervisornavigationLinks = [
  { id: 1, title: "Home", path: "", icon: Home },
  {
    id: 2,
    title: "Work Order",
    path: "work-order",
    icon: Settings,
    submenu: [
      { id: 201, title: "All Works", path: "work-order" },
      { id: 202, title: "Pending", path: "work-order?status=pending" },
      { id: 203, title: "In Progress", path: "work-order?status=in progress" },
      { id: 204, title: "Completed", path: "work-order?status=completed" },
    ],
  },
  {
    id: 3,
    title: "Repair Report",
    path: "repair-report",
    icon: FileText,
  },
  {
    id: 4,
    title: "Maintenance Report",
    path: "maintenance-report",
    icon: ClipboardCheck,
  },
  { id: 5, title: "Attendance", path: "attendance", icon: UserCheck },
  // { id: 6, title: "Vendor", path: "vendor", icon: Building2 },
  { id: 7, title: "Feedback", path: "feedback", icon: FileText },
  { id: 8, title: "Overtime", path: "overtime", icon: Clock },
];
